<template>
  <ux-modal class="add-lang" width="540px" v-model="showModal" :title="title" :close="close">
    <div class="addlang-cont">
      <!-- 内容 -->
      <div class="addlang-verify">
        <ux-form
          class="my-vertical-form"
          ref="form"
          :rules="rules"
          :data="formData"
          hide-btn
          width="380"
        >
          <!-- key -->
          <ux-form-item label="Key" prop="key" key="key">
            <ux-input
              noSpace
              v-model="formData.key"
              :placeholder="$t('HT.rules.addLang.key')"
            ></ux-input>

            <div class="form-key-info">
              <ux-tooltip :content="content" placement="bottom">
                <i class="ux_icon_tips_normal icon-form-key-info"></i>
              </ux-tooltip>
            </div>
          </ux-form-item>

          <!-- 类型 -->
          <ux-form-item :label="$t('HT.upgrade.type')" prop="key_type" key="key_type">
            <ux-radio v-model="formData.key_type" :options="$opt.langKeyType"></ux-radio>
          </ux-form-item>

          <!-- 场景 -->
          <ux-form-item :label="$t('HT.language.scene')" prop="key_scene" key="key_scene">
            <ux-select v-model="formData.key_scene" :options="$opt.langKeyScene"></ux-select>
          </ux-form-item>

          <!-- 原文文本 -->
          <ux-form-item :label="$t('HT.language.zh')" prop="zh_value" key="zh_value">
            <ux-input
              type="textarea"
              :rows="2"
              v-model="formData.zh_value"
              :placeholder="$t('HT.language.zhVal.placeholder')"
            ></ux-input>
          </ux-form-item>
          <!-- 翻译文本 -->
          <ux-form-item :label="$t('HT.language.en')" prop="en_value" key="en_value">
            <ux-input
              type="textarea"
              :rows="2"
              v-model="formData.en_value"
              :placeholder="$t('HT.language.enVal.placeholder')"
            ></ux-input>
          </ux-form-item>
        </ux-form>
      </div>
    </div>
    <template slot="footer">
      <div class="addlang-footer">
        <ux-button plain @click="close">{{ $t('HT.cancel') }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ $t('HT.save') }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import timeButton from '@/views/template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';

export default {
  name: 'AddLang',
  components: {
    timeButton,
    imgVerify
  },
  props: {
    // 用户名
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false,
      rules: this.$rul.addLang(this),
      formData: {
        key: '', // Key
        key_type: '', // 类型
        key_scene: '', // 场景
        zh_value: '', // 原文文本
        en_value: '' // 翻译文本
      },
      content: (h) => {
        return h(
          'div',
          {
            style: {
              width: '270px',
              'font-size': '14px',
              'line-height': '20px',
              padding: '0 8px'
            }
          },
          [
            h('p', {}, this.$t('HT.addLang.content.text1')),
            h('p', {}, this.$t('HT.addLang.content.text2')),
            h('p', {}, this.$t('HT.addLang.content.text3')),
          ]
        );
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.showModal = true;
      this.formData = { ...this.info };
    });
  },
  computed: {
    title() {
      return this.info.id ? this.$t('HT.language.edit') : this.$t('HT.language.add');
    }
  },

  methods: {
    /**
     * 关闭弹窗
     */
    close() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$uxLoading.show();
          const fnName = this.info.id ? 'editI18n' : 'addI18n';
          this.$api.language[fnName](this.formData, { hideMsg: true })
            .then((res) => {
              if (res.code == 10000) {
                this.$uxMessage.success(this.$t('HT.addApi.operateSuccess'));
                this.$emit('update-info');
                this.close();
              }
            })
            .catch((err) => {
              this.$uxMessage.error(err.response.data.sub_msg);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addlang-cont {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;

  .addlang-verify {
    position: relative;
    flex: 1;
    padding: 0 40px;

    .addlang-errorbox {
      color: $color-error;
    }

    .addlang-verify-item {
      width: 240px;
      margin-bottom: 24px;
      color: $color-text-secondary;

      &:last-of-type {
        margin-bottom: 0;
      }

      .verify-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        height: 16px;
        color: $color-text-secondary;
      }

      .verify-control {
        display: flex;
        align-items: center;
        color: $color-title;
        height: 32px;

        &.verify-code {
          justify-content: flex-start;

          .ux-input {
            width: 96px;
          }
        }
      }
    }

    .time-button {
      margin-left: 24px;
    }

    .min-input {
      width: 110px;
      margin-right: 20px;
    }
  }
}

.addlang-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}

.form-key-info {
  position: absolute;
  top: 0;
  left: 30px;
  display: block;
  width: 16px;
  height: 16px;
}
</style>

<style>
.icon-form-key-info {
  font-size: 16px;
  color: #8690aa;
}
</style>
